export const MODAL_CREATE = 1;
export const MODAL_CREATE_TITLE = "Create Leave Request";
export const MODAL_EDIT = 2;
export const MODAL_EDIT_TITLE = "Edit Leave Request";
export const MODAL_DETAIL = 3;
export const MODAL_DETAIL_TITLE = "Leave Request Detail";